import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hkcli',
  templateUrl: './hkcli.component.html',
  styleUrls: ['./hkcli.component.scss']
})
export class HkcliComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
